var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftOpening(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 49,
    viewBox: "0 0 45 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6967 6.125H16.875C13.3395 6.125 11.5717 6.125 10.4733 7.32098C9.375 8.51696 9.375 10.4419 9.375 14.2917V34.7083C9.375 38.5581 9.375 40.483 10.4733 41.679C11.5717 42.875 13.3395 42.875 16.875 42.875H28.125C31.6605 42.875 33.4283 42.875 34.5266 41.679C35.625 40.483 35.625 38.5581 35.625 34.7083V18.0247C35.625 17.1902 35.625 16.7729 35.4823 16.3977C35.3395 16.0225 35.0686 15.7275 34.5267 15.1374L27.3484 7.32098C26.8064 6.73088 26.5355 6.43583 26.1909 6.28041C25.8463 6.125 25.4631 6.125 24.6967 6.125Z",
    stroke: "#33363F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 26.5415L28.125 26.5415",
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 34.7085L24.375 34.7085",
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 6.125V14.2917C24.375 16.2166 24.375 17.179 24.9242 17.777C25.4733 18.375 26.3572 18.375 28.125 18.375H35.625",
    stroke: "#33363F",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftOpening);
export default __webpack_public_path__ + "static/media/ShiftOpening.cd111e485c0d25df9802f65defb1931f.svg";
export { ForwardRef as ReactComponent };